import cn from 'classnames';

import { MembershipPackageName, PostType, User } from 'common/interfaces/api';
import useStore from 'store/timeline';
import useGlobalStore from 'store/global';

import styles from './LockedMessage.module.scss';
import Button from 'components/common/Button';
import { isGoldMember } from 'common/utils/membership';
import { ScreenName } from 'common/utils/pp_tracking';
import {
  checkIsCreatorPaidPost,
  exCreatorPostLockMessage,
} from 'common/utils/post';
import { isSubbedPrimePlusBefore } from 'common/utils/payment';

export enum LockedType {
  Text = 'text',
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
}
export type Props = {
  type: LockedType;
  postAuthor: User;
  postType: PostType;
};

export default function LockedMessage({
  type,
  postAuthor,
  postType,
}: Props): JSX.Element {
  const currentUser = useStore((state) => state.currentUser);
  const showLogin = useGlobalStore((state) => state.showLogin);
  const showPaymentDialog = useGlobalStore((state) => state.showPaymentDialog);
  const setSnackbarMessage = useGlobalStore(
    (state) => state.setSnackbarMessage
  );
  const setShowMembershipPayDialog = useGlobalStore(
    (state) => state.setShowMembershipPayDialog
  );
  let content;
  if (currentUser) {
    const handleTrialClick = () => {
      if (postType === PostType.Gold && !isGoldMember(currentUser)) {
        setShowMembershipPayDialog({
          open: true,
          showMembershipStatus: false,
          initPackage: MembershipPackageName.Platinum,
          screen: ScreenName.PostDetail,
        });
        return;
      }
      if (!postAuthor) return;
      // in case of value is undefined, still can open payment dialog
      if (
        postAuthor.is_open_for_subscription === false &&
        checkIsCreatorPaidPost(postType)
      ) {
        setSnackbarMessage({
          type: 'error',
          text: exCreatorPostLockMessage(postType),
        });
        return;
      }
      showPaymentDialog({ creator: postAuthor });
    };
    const actionBtnText = () => {
      if (postType === PostType.Gold && !isGoldMember(currentUser)) {
        return 'GOLDメンバーシップに登録して視聴しましょう';
      }
      if (postType === PostType.Paid) {
        return postAuthor?.is_subscribed_before
          ? 'プライム登録を再開'
          : 'プライム登録を無料体験';
      }
      if (postType === PostType.Plus) {
        return isSubbedPrimePlusBefore(postAuthor)
          ? 'プライムPlusを再開'
          : 'プライムPlusを無料体験';
      }
    };
    content = (
      <div className={styles.registerBtn}>
        <Button text={actionBtnText()} onClick={() => handleTrialClick()} />
      </div>
    );
  } else {
    content = (
      <div className={styles.registerBtn}>
        <Button
          text="無料でログインする"
          onClick={() => showLogin({ authorName: postAuthor.name })}
        />
      </div>
    );
  }

  return (
    <div className={cn(styles.lockedOverlay, styles[type])}>{content}</div>
  );
}
